
export default class List {

	static getHolderSelectors = () => ['.list-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#onload();
	}

	#onload() {
		this.#setFilters();
		this.#filterBySearchQuery();
	}

	#setFilters() {
		let filter = this.#holderElement.querySelector('.filter');

		filter.querySelectorAll('.btn').forEach(button => {
			button.addEventListener('click', (event) => {
				document.querySelector('html').style.overflowY = document.querySelector('html').style.overflowY === 'hidden' ? 'unset' : 'hidden';
			});
		});

		if (filter.querySelector('.filter-overlay')) {
			filter.querySelector('.filter-overlay').addEventListener('click', (event) => {
				let isOptionSelected = false;
				filter.querySelectorAll('.option').forEach(option => {
					if (option.contains(event.target)) {
						isOptionSelected = true;
					}
				});
				if (!isOptionSelected) {
					event.preventDefault();
				}

				if (!filter.querySelector('.filter-overlay').querySelector('.popup').contains(event.target) || filter.querySelector('.filter-close').contains(event.target)) {
					filter.querySelector('.btn-filter').click();
				}
			});

			filter.querySelector('.filter-overlay').querySelectorAll('input[type=radio]').forEach(radioInput => {
				radioInput.addEventListener('change', (event) => {
					event.preventDefault();

					let filterValue = filter.querySelector('input[name="job-level-option"]:checked')?.value;
					let soryByValue = filter.querySelector('input[name="type-option"]:checked')?.value;
					let listingCount = 0;

					this.#holderElement.querySelectorAll('.item').forEach(item => {
						item.classList.remove('hide');
						if (filterValue && !item.dataset.filter.includes(filterValue)) {
							item.classList.add('hide');
							return;
						}
						if (soryByValue && !item.dataset.sortBy.includes(soryByValue)) {
							item.classList.add('hide');
							return;
						}
						listingCount++;
					});

					this.#holderElement.querySelector('.listing-count').textContent = listingCount + '';
					this.#holderElement.querySelector('.plural').style.display = listingCount <= 1 ? 'none' : 'inline-block';
				});
			});
		}

		filter.querySelector('.sort-by-overlay').addEventListener('click', (event) => {
			let isOptionSelected = false;
			filter.querySelectorAll('.option').forEach(option => {
				if (option.contains(event.target)) {
					isOptionSelected = true;
				}
			});
			if (!isOptionSelected) {
				event.preventDefault();
			}

			if (!filter.querySelector('.sort-by-overlay').querySelector('.popup').contains(event.target) || filter.querySelector('.sort-by-close').contains(event.target)) {
				filter.querySelector('.btn-sort-by').click();
			}
		});

		filter.querySelector('.sort-by-overlay').querySelectorAll('input[type=radio]').forEach(radioInput => {
			radioInput.addEventListener('change', (event) => {
				event.preventDefault();

				let sortByValue = filter.querySelector('input[name="sort-by-option"]:checked')?.value;
				let numberOfItems = this.#holderElement.querySelectorAll('.item').length;

				for (var i = 1; i <= numberOfItems; i++) {
					if (sortByValue === 'newest-to-oldest') {
						this.#holderElement.querySelectorAll('.item')[i-1].style.order = i;
					} else if (sortByValue === 'oldest-to-newest') {
						this.#holderElement.querySelectorAll('.item')[i-1].style.order = numberOfItems - i + 1;
					}
				}
			});
		});
	}

	#filterBySearchQuery() {
		const params = new URLSearchParams(window.location.search);

		const location = params.get('location') ? params.get('location') : 'all';
		const role = params.get('role') ? params.get('role') : 'all';

		let listingCount = 0;

		this.#holderElement.querySelectorAll('.item').forEach(item => {
			if (location !== 'all' && item.dataset.location !== location) {
				item.classList.add('hide');
				return;
			}
			if (role !== 'all' && item.dataset.filter !== role) {
				item.classList.add('hide');
				return;
			}
			listingCount++;
		});

		this.#holderElement.querySelector('.listing-count').textContent = listingCount + '';
		this.#holderElement.querySelector('.plural').style.display = listingCount <= 1 ? 'none' : 'inline-block';
	}

}
